import type { SdrWeeklyPoint } from '../../../api/projectManagement';

/** A leading bar shorter than this many days is folded into the next week. */
const MIN_STUB_DAYS = 3;

function spanDays(p: SdrWeeklyPoint): number {
  if (!p.from || !p.to) return 7;
  return Math.round((Date.parse(`${p.to}T00:00:00Z`) - Date.parse(`${p.from}T00:00:00Z`)) / 86_400_000) + 1;
}

/**
 * Pure: a period that starts on a Sunday gave the chart a one-day "13 Sep" bar
 * beside the 14 Sep week. A leading bar under MIN_STUB_DAYS days joins the next
 * one ("13 Sep – 20 Sep"), so every bar is close to a week and the total is
 * unchanged. The last bar (the week in progress) stays as it is. Exported for tests.
 */
export function mergeLeadingStub(points: readonly SdrWeeklyPoint[]): SdrWeeklyPoint[] {
  const [first, second, ...rest] = points;
  if (!first || !second || spanDays(first) >= MIN_STUB_DAYS || !first.from) return [...points];
  return [{ weekStart: second.weekStart, from: first.from, to: second.to ?? second.weekStart, total: first.total + second.total }, ...rest];
}
